import { render, staticRenderFns } from "./SetupBody.vue?vue&type=template&id=cb279f76&scoped=true"
import script from "./SetupBody.vue?vue&type=script&lang=js"
export * from "./SetupBody.vue?vue&type=script&lang=js"
import style0 from "./SetupBody.vue?vue&type=style&index=0&id=cb279f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb279f76",
  null
  
)

export default component.exports